<template>
  <section id="about" class="tf-section tf-about pb-mobie">
        <div class="container">
            <div class="row">
                <div class="col-md-5">
                    <div class="content-about mobie-40" data-aos="fade-up" data-aos-duration="800">
                        <div class="tf-title st2">
                            <p class="h8 sub-title">Who We Are</p>
                            <h4 class="title" id="sons-haephaestus-title">SONSOFHEPHAESTUS</h4>
                        </div>
                        <p><b>SonsOfHephaestus</b> is a way to empower our community and keep building with our undying strength.
                            <br>
                            It tells in part, the building journey of Relsify and constitutes the early-days motives, the ongoing facts, & what we envision.<br>
                            Through lame and pain we have built, countless times we have encountered challenges, but we have kept building.<br>
                            Now is the time for our community to be reminded that building is the only option.<br>
                            You either build or build!<br>
                            Whether it's a vision, a dream, a relationship, a startup, a career, a business, whatever it is...<br>
                            SonsOfHephaestus is not a mere jpeg, but an identity & access for anyone who is building or desires to build with so much zeal, temerity, doggedness, and passion.<br>

                            </p>
                            <!-- <a class="tf-button st2 btn-effect" href="#">   
                                <span class="boder-fade"></span>                                     
                                <span class="effect">Mint Nfts</span>
                            </a> -->
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="wrap-about p-l70" data-aos="fade-up" data-aos-duration="800">
                        <div class="box-text corner-box active">
                            <div class="h7">Adapted From History</div>
                            <p>Hephaestus, the Greek god of craftsmanship and technology. Against all odds, Heaphaestus built, so have we at Relsify.</p>
                        </div>
                        <div class="box-text corner-box">
                            <div class="h7">Coined For Story</div>
                            <p>The 7 offspring of Hephaestus were his pride alongside his works. Likewise, the SonsOfHephaestus, our community, shall forever be our pride and greatest asset.</p>
                        </div>
                        <div class="box-text corner-box mb-0">
                            <div class="h7">Executed For Pedigree</div>
                            <p>SonsOfHephaestus forms Relsify's Tier-1 community members who ingrains our story and have governance rights, special privileges & exclusive ongoing benefits of our products.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'AboutUsComponent'
}
</script>

<style>
@media only screen and (max-width: 991px) {
    h4#sons-haephaestus-title {
        font-size: 35px;
    }
}

@media only screen and (max-width: 767px) {
    h4#sons-haephaestus-title {
        font-size: 30px;
    }
}
</style>